import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import ListLoader from 'Pods/Shared/ListLoader'
import Icon from 'Pods/Shared/Icon/Icon'
import DesignerRow from './Components/DesignerRow'
import ProjectsSearchForm from './Components/ProjectsSearchForm'
import SearchForm from './Components/SearchForm'


class DesignersList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      data: this.props.data,
      meta: this.props.meta,
      isDataFetched: false,
      reloadFetch: false,
      filters: this.getDefaultFilters(),
      filtersHidden: this.props.inviteDesignersPage,
      isDesignerFound: true,
      cart: {},
      reloadDesigners: false,
    }

    this.onFetchSuccess = this.onFetchSuccess.bind(this)
    this.getDefaultFilters = this.getDefaultFilters.bind(this)
    this.fetchData = this.fetchData.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handlePageChange = this.handlePageChange.bind(this)
    this.handleFiltersChange = this.handleFiltersChange.bind(this)
    this.handleSortChange = this.handleSortChange.bind(this)
    this.resetFilters = this.resetFilters.bind(this)
    this.onFiltersToggle = this.onFiltersToggle.bind(this)
    this.handleSearchFilterChange = this.handleSearchFilterChange.bind(this)
    this.handleCartUpdate = this.handleCartUpdate.bind(this)
    this.trackFilterChange = this.trackFilterChange.bind(this)
  }

  componentDidMount() {
    App.events.subscribe('app:cart:updated', this.handleCartUpdate)

    if (this.props.inviteDesignersPage) {
      this.preselectFilters()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.data !== this.state.data) this.setState({ reloadDesigners: true })
  }

  getDefaultFilters() {
    return {
      page: 1,
      perPage: 10,
      sortBy: 'relevance',
      searchFilter: 'designer_name',
      sortMode: 'designers_with_models',
      keywords: '',
      coordinates: null,
      skills: [],
      software: [],
      isOpenForHire: false,
    }
  }

  preselectFilters() {
    const newState = this.state
    newState.filters.software = this.props.softwareIds
    newState.filters.skills = this.props.skillIds
    newState.filters.isOpenForHire = true
    newState.isDataFetched = false
    newState.reloadFetch = true

    this.setState(newState)
    this.fetchData(newState.filters)
  }

  trackFilterChange({ name, value }) {
    window.filterTracker({
      name,
      value,
      searchTerm: '',
      type: '3d designer',
    })
  }

  handleSearch(data) {
    const keywords = data.keywords
    const newState = this.state
    newState.reloadFetch = true
    newState.filters.searchFilter = keywords ? data.searchFilter : 'designer_name'
    newState.filters.keywords = keywords
    newState.filters.page = 1
    newState.filters.sortBy = 'relevance'

    if (keywords) {
      if (newState.filters.searchFilter === 'location') {
        this.trackFilterChange({ name: 'location', value: keywords })
        window.searchTracker({ searchTerm: '', type: '3d designer' })
      } else {
        window.searchTracker({ searchTerm: keywords, type: '3d designer' })
      }
    } else {
      window.removeCurrentSearchFilter({ name: 'location' })
    }

    this.setState({ ...newState, isDataFetched: false })

    this.fetchData(newState.filters)
  }

  fetchData(filters) {
    const params = {
      page: filters.page,
      per_page: filters.perPage,
      sort_by: filters.sortBy,
      sort_mode: filters.sortMode,
      search_filter: filters.searchFilter,
      keywords: filters.keywords,
      coordinates: filters.coordinates,
      skills: filters.skills,
      software: filters.software,
      open_for_hire: filters.isOpenForHire,
    }

    return axios.get('/api/internal/users', { params })
      .then((response) => this.onFetchSuccess(response))
      .catch(() => App.events.publish('app:notification:flash:error', 'Error'))
  }

  onFetchSuccess(response) {
    this.setState(prevState => ({
      data: this.state.reloadFetch ? (
        response.data.data.length !== 0 ? response.data.data : response.data.meta.topDesigners
      ) : (
        prevState.data.concat(response.data.data)
      ),
      meta: response.data.meta,
      isDataFetched: true,
      isDesignerFound: response.data.data.length > 0,
      reloadDesigners: false,
    }))
  }

  handlePageChange(pageNumber) {
    const newState = this.state
    newState.reloadFetch = false
    newState.filters.page = pageNumber

    if (newState.filters.keywords.length === 0) {
      newState.filters.searchFilter = 'designer_name'
    }

    this.setState(newState, () => this.fetchData(newState.filters))
  }

  handleFiltersChange(newFilters, resetSorting = true) {
    newFilters = newFilters || this.state.filters
    newFilters.page = 1

    if (resetSorting) {
      newFilters.sortBy = 'relevance'
    }

    if (newFilters.keywords.length === 0) {
      newFilters.searchFilter = 'designer_name'
    }

    this.setState({ filters: newFilters, reloadFetch: true })

    this.fetchData({ ...newFilters })
  }

  handleSortChange(newFilters) {
    this.handleFiltersChange(newFilters, false)
  }

  handleSearchFilterChange(searchFilter) {
    const newState = this.state
    newState.filters.searchFilter = searchFilter

    this.setState(newState)
  }

  resetFilters() {
    const newFilters = this.getDefaultFilters()

    this.setState({
      filters: newFilters,
      reloadFetch: true,
    }, () => this.fetchData(newFilters))
  }

  handleCartUpdate(legacyCartResponseObject) {
    const newState = this.state

    newState.cart = {
      value: legacyCartResponseObject.meta.finalPrice,
      creditsAvailable: legacyCartResponseObject.meta.storeCreditsLeft,
      applicableCldValue: legacyCartResponseObject.meta.minPurchaseAmountForCld,
      saleOffDiscount: legacyCartResponseObject.meta.saleOffDiscount,
      isSaleOff: legacyCartResponseObject.meta.saleCampaignActive,
      itemIds: legacyCartResponseObject.data.map((obj) => obj.attributes.itemId),
    }

    this.setState(newState)
  }

  onFiltersToggle() {
    this.setState(prevState => ({
      filtersHidden: !prevState.filtersHidden,
    }))
  }

  render() {
    return (
      <div className={`container-fixed designers-list ${this.props.className}`}>
        <h1>3D Designers</h1>
        <div className="row">
          <div className="col-12 designers-list__form">
            {this.props.inviteDesignersPage ? (
              <ProjectsSearchForm
                onFiltersChange={this.handleFiltersChange}
                onSortChange={this.handleSortChange}
                onSearch={this.handleSearch}
                onSearchFilterChange={this.handleSearchFilterChange}
                resetFilters={this.resetFilters}
                filters={this.state.filters}
                meta={this.state.meta}
              />
            ) : (
              <SearchForm
                onFiltersChange={this.handleFiltersChange}
                onSortChange={this.handleSortChange}
                onSearch={this.handleSearch}
                onSearchFilterChange={this.handleSearchFilterChange}
                resetFilters={this.resetFilters}
                filters={this.state.filters}
                meta={this.state.meta}
              />
            )}
          </div>
        </div>

        {!this.state.isDesignerFound && (
          <Fragment>
            <div className="designers-list__no-designers">
              <p className="heading-32 text-default"><Icon type={['far', 'frown-open']} notSpaced /></p>
              <p className="heading-18">
                No designers found
              </p>
              <p className="text-default">Adjust your filters to get better results</p>
            </div>
            <p className="heading-24">Top designers</p>
          </Fragment>
        )}

        <Fragment>
          {this.state.data.map((user) => {
            return (
              <DesignerRow
                userId={user.id}
                user={user.attributes}
                onFiltersChange={this.handleFiltersChange}
                filters={this.state.filters}
                reload={this.state.reloadDesigners}
                key={`designer-row-${user.id}`}
                messagingForbidden={this.props.messagingForbidden}
                inviteDesignersPage={this.props.inviteDesignersPage}
                isInvited={this.props.invitedUserIds.includes(parseInt(user.id))}
                jobId={this.props.jobId}
                cart={this.state.cart}
              />
            )
          })}
        </Fragment>

        <p className="u-text-center">
          <ListLoader
            totalPages={this.state.meta.totalPages}
            currentPage={this.state.filters.page}
            onShowMore={this.handlePageChange}
            buttonClass="btn btn-outline-default designers-list__load-more"
            text="Load more"
          />
        </p>
      </div>
    )
  }
}

DesignersList.propTypes = {
  data: PropTypes.array,
  meta: PropTypes.object,
  messagingForbidden: PropTypes.bool,
  inviteDesignersPage: PropTypes.bool,
  invitedUserIds: PropTypes.array,
  jobId: PropTypes.number,
  className: PropTypes.string,
  softwareIds: PropTypes.array,
  skillIds: PropTypes.array,
}

DesignersList.defaultProps = {
  data: [],
  meta: {},
  messagingForbidden: false,
  inviteDesignersPage: false,
  invitedUserIds: [],
  jobId: null,
  className: '',
  softwareIds: [],
  skillIds: [],
}

export default DesignersList
